import axios from "axios";
import { trackEvent } from "./analytics";

let strength = {
    1: "Weak",
    2: "Fair",
    3: "Good",
    4: "Strong",
}

let password = document.getElementById('new_password');
let text = document.getElementById('password_status');
let passwordMeter = document.getElementById('password_meter_color')

let chars = document.getElementById('12_char')
let upper_case = document.getElementById('upper_case')
let lower_case = document.getElementById('lower_case')
let punctuation = document.getElementById('punctuation')
if (password) {
    password.addEventListener('input', function () {
        let val = password.value;
        if (val.length === 0) {
            document.getElementById('password_meter').style.display = 'none'
            document.getElementById('password_rules').style.display = 'none'
            return
        } else {
            document.getElementById('password_meter').style.removeProperty('display')
            document.getElementById('password_rules').style.removeProperty('display')
        }
        let score = 0
        if (val.length >= 12) {
            score++
            chars.style.display = 'none'
        } else {
            chars.style.removeProperty('display')
        }
        if (val.match(/[a-z]/)) {
            score++
            lower_case.style.display = 'none'
        } else {
            lower_case.style.removeProperty('display')
        }

        if (val.match(/[A-Z]/)) {
            score++
            upper_case.style.display = 'none'

        } else {
            upper_case.style.removeProperty('display')
        }

        if (val.match(/[`!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?~]/)) {
            score++
            punctuation.style.display = 'none'
        } else {
            punctuation.style.removeProperty('display')
        }

        switch (score) {
            case 1:
                passwordMeter.classList.add("is-weak");
                passwordMeter.classList.remove('is-fair')
                passwordMeter.classList.remove('is-good')
                passwordMeter.classList.remove('is-strong')
                break
            case 2:
                passwordMeter.classList.add("is-fair");
                passwordMeter.classList.remove('is-weak')
                passwordMeter.classList.remove('is-good')
                passwordMeter.classList.remove('is-strong')
                break
            case 3:
                passwordMeter.classList.add("is-good");
                passwordMeter.classList.remove('is-weak')
                passwordMeter.classList.remove('is-fair')
                passwordMeter.classList.remove('is-strong')
                break
            case 4:
                passwordMeter.classList.add("is-strong");
                passwordMeter.classList.remove('is-weak')
                passwordMeter.classList.remove('is-fair')
                passwordMeter.classList.remove('is-good')
                document.getElementById('password_rules').style.display = 'none'
                break
        }

        passwordMeter.style.width = (score / 4 * 100) + '%'

        // This updates the password meter text
        if (val !== "") {
            if (score > 0)
                text.innerHTML = strength[score];
        } else {
            text.innerHTML = "";
        }
    });
}

let confirmPassword = document.getElementById('confirm_password');

if (confirmPassword) {
    let password_match_status = document.getElementById('password_match_status')
    confirmPassword.addEventListener('input', function () {
        let confirm_password = confirmPassword.value
        if (confirm_password.length > 0) {
            document.getElementById('password_match').style.removeProperty('display')
            if (confirm_password === password.value) {
                password_match_status.classList.remove('error')
                password_match_status.classList.add("ok")
                password_match_status.innerHTML = "YES"
            } else {
                password_match_status.classList.remove('ok')
                password_match_status.classList.add("error")
                password_match_status.innerHTML = "NO"
            }
        } else {
            document.getElementById('password_match').style.display = 'none'
        }
    })
}
function propertyDelete (propertiesCount) {
    trackEvent({name: 'pm_properties_deleteconfirm', type: 'Action'})
    let id = document.getElementById('deleted-property-id').value
    axios.post('/properties/delete/' + id, {
        propertiesCount
    }).then(function (resp) {
        let error_title_element = document.getElementById('error-title')
        let error_title_body = document.getElementById('error-body');
        if (resp.data.success) {
            error_title_element.innerHTML = 'Property deleted'
            error_title_body.innerHTML = 'Property Successfully deleted'
            document.getElementById('property-' + id).remove()
        } else {
            error_title_body.innerHTML = 'Error deleting property, please try again'
        }
        $("#error-modal").modal('show')
    })
    $("#delete-property").modal('hide')
}

function propertyDeletionConfirmation (id) {
    trackEvent({name: 'pm_properties_delete', type: 'Action'})
    document.getElementById('deleted-property-id').value = id
    $("#delete-property").modal('show')
}

function selectProperty (property) {
    trackEvent({name: 'pm_properties_select', type: 'Action'})
    document.body.classList.add('sidebar-li-loading-cursor');
    axios.put('/update/session', {
        selectedPropertyId: property.id,
        selected_property: property
    }).then(function (resp) {
        if (resp.data.status) {
            if ('/contractors' != window.location.pathname) {
                window.location.pathname = '/contractors';
            } else {
                window.location.reload(true);
            }
        }
    })
    .catch(error => console.error('Error updating session:', error));
}
function delete_custom_policy (id)
{
    console.log(id);
    $("#delete-custom-policy").modal('show');
    document.getElementById('custom_policy').value=id;
}
function edit_custom_policy (id,name)
{
    $("#edit-policy").modal('show');
    document.getElementById('policy_id').value=id
    document.getElementById('policy_name').value=name;
}
function save_custompolicy ()
{
    if(  document.getElementById('policy_name').value=="")
    {
        document.getElementById('edit-policy-error').classList.remove('d-none')
    }
    else
    {
        if (!$("#edit-policy-error").hasClass("d-none"))
        {
            document.getElementById('edit-policy-error').classList.add('d-none')
        }
        document.getElementById("edit-policy-form").submit();
    }
}
function cancel_custompolicy (){
    if (!$("#edit-policy-error").hasClass("d-none"))
    {
        document.getElementById('edit-policy-error').classList.add('d-none')
    }
    $("#edit-policy").modal('hide');
}
// this makes the functions exported for use by blade template JS scripts and is used by webpack
export const accountModule = {
    propertyDelete,
    propertyDeletionConfirmation,
    selectProperty,
    delete_custom_policy,
    edit_custom_policy,
    save_custompolicy,
    cancel_custompolicy,
}